const storageKey = 'verify_email_redirect';

export const setVerifyEmailRedirect = (path: string) => {
  window.localStorage.setItem(storageKey, path);
};

export const getVerifyEmailRedirect = () => {
  return window.localStorage.getItem(storageKey) || '/';
};
